/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import images from "../../images/print-logo.png";
import toast from "react-hot-toast";
import Select from "react-select";

import { approvepayment, assignPaymentApi, getACHNumberEmails, putNextStatus, putPaymentTransactionId, putPaymentType, updatePaymentDetails } from "../../api/currentApplications";
import { API_URL, REACT_APP_URL, PAYMENT_LINK } from "../../api";
import { Netsuite } from "../../schema/NetSuiteSchema";
import CommonNavigation from "../commonNavigation/CommonNavigation";
import { getNetsuiteInitialValue, netSuiteUpsertRecords } from "../../api/Netsuite";
import { getApplicationPaymentFee } from "../../utils/getPaymentAmount";
import ApplicationPaymentsLoading from "../loaders/ApplicationPaymentsLoading";
import PaymentsLoading from "../loaders/PaymentLoading";
import { useAtoms } from "../../hooks/useAtoms";
import { useUser } from "../../hooks/useUser";
import { useApplication } from "../../hooks/useApplication";
import { createContact, getContactsByCompanyId } from "../../api/crm";
import DashBoardLoading from "../loaders/DashBoardLoading";
import { PaymentInformation } from "./PaymentInformation";
import { OldApplication } from "./OldApplication";
import { AuthorizeApplicationFee } from "./AuthorizeApplicationFee";

const ApplicationPayment = (props) => {
  const applicationID = props.match.params.applicationID;
  localStorage.setItem("applicationId", applicationID);
  const [netsuiteField, setNetsuiteValue] = React.useState({
    CASHSALE: {},
    VENDORBILL: {},
  });

  const { contact = {}, roleName = "" } = useUser() || {};
  const { email = "" } = contact;
  const [records, setRecords] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [editPaymentNotes, setEditPaymentNotes] = useState(false);
  const [oldApplication, setOldApplication] = useState(false);
  const { setNavigation, setHideNavigation } = useAtoms();
  const [emails, setEmails] = useState("");

  const application = useApplication();
  const { paymentby, ApplicationTitle } = application;

  setHideNavigation(false);
  setNavigation(`Application Payment ${" "} ${ApplicationTitle ? ApplicationTitle : props.match.params.applicationID} `);

  const getNetSuiteValues = async (records, applicationID) => {
    for (let i = 0; i < records.length; i++) {
      const record = records[i];
      let res = await getNetsuiteInitialValue(applicationID, record);
      let response = res?.data?.data;
      setNetsuiteValue((initialValue) => ({
        ...initialValue,
        [records]: response,
      }));
    }
  };

  const updatePaymentType = async (paymentStep, paymentType) => {
    setLoading(true);
    const applicationID = props.match.params.applicationID;
    let data = {
      applicationID: applicationID,
      paymentStep: paymentStep,
      paymentType: paymentType,
    };
    let updatePaymentType = await putPaymentType(data);

    if (updatePaymentType) {
      window.location.reload();
    }
    setLoading(false);
  };

  const updateManualPayment = async (paymentStep = "event1paymentType") => {
    setLoading(true);
    const applicationID = props.match.params.applicationID;
    const transactionId = document.getElementById("transactionId").value;
    let data = {
      applicationID: applicationID,
      paymentStep: paymentStep,
      transactionId: transactionId,
    };
    let updateTransactionId = await putPaymentTransactionId(data);
    const { CASHSALE, VENDORBILL } = netsuiteField;
    await netSuiteUpsertRecords(applicationID, "CASHSALE", CASHSALE);
    await netSuiteUpsertRecords(applicationID, "VENDORBILL", VENDORBILL);
    if (updateTransactionId.data) {
      await approvepayment(applicationID);
      let value = await putNextStatus(applicationID, 1);
      if (value.data) {
        window.location = `${REACT_APP_URL}/review/${applicationID}`;
      }
    }
    setLoading(false);
  };

  const updatePaymentTransiction = async (paymentStep = "event1paymentType") => {
    setLoading(true);
    const applicationID = props.match.params.applicationID;
    const transactionId = document.getElementById("transactionId").value;
    let data = {
      applicationID: applicationID,
      paymentStep: paymentStep,
      event1transactionId: transactionId,
    };
    let updateTransactionId = await updatePaymentDetails(data);

    if (updateTransactionId) {
      window.location = `${REACT_APP_URL}/applicationPayment/${applicationID}`;
    }
    setLoading(false);
  };

  const updateTransictionId = () => {
    setEditPaymentNotes(true);
  };

  const validatepayment = async () => {
    setLoading(true);
    window.location = `${REACT_APP_URL}/review/${props.match.params.applicationID}`;
  };

  const updateTransictionNumber = async () => {
    setLoading(true);
    const applicationID = props.match.params.applicationID;
    const transactionIds = document.getElementById("transactionIds").value;
    let data;
    if (emails.includes(contact.email) && !transactionIds) {
      data = {
        applicationID: applicationID,
        event1transactionNumber: "",
      };
    } else {
      data = {
        applicationID: applicationID,
        event1transactionNumber: transactionIds,
      };
    }
    let updateTransactionIds = await updatePaymentDetails(data);

    if (updateTransactionIds) {
      window.location = `${REACT_APP_URL}/applicationPayment/${applicationID}`;
    }
    setLoading(false);
  };

  const assignPayment = async (contact) => {
    const applicationID = props.match.params.applicationID;
    let linkUrl = REACT_APP_URL + `/applicationPayment/${applicationID}`;
    let data = {
      applicationID: applicationID,
      LinkUrl: linkUrl,
      agreementType: "applicationPayment",
    };
    if (contact) {
      const { name, email } = contact;
      data["name"] = name;
      data["email"] = email;
    }

    if (paymentby) {
      data = { ...paymentby, ...data };
    }

    await assignPaymentApi(data);
    window.location = `${REACT_APP_URL}/applicationPayment/${applicationID}`;
  };

  const getApplicantEmail_ACH_Number_Not_Exist = async (roleName, email) => {
    try {
      const res = await getACHNumberEmails();
      const emails = JSON.parse(res?.data?.data) || [];
      if (roleName === "Approving Accountant") {
        emails.push(email);
      }
      setEmails(emails);
    } catch (error) {
      setEmails([]);
    }
  };

  useEffect(() => {
    const arrayOfnesuite = [];
    Netsuite.sections.forEach((section) => {
      section.questions.forEach((val) => {
        if (val.applicationPayment === "true") {
          arrayOfnesuite.push(val);
        }
      });
    });
    const array = arrayOfnesuite.map((section) => section?.recordName);
    setRecords(array);
  }, []);

  useEffect(() => {
    getNetSuiteValues(records, props.match.params.applicationID);
  }, [records, props.match.params.applicationID]);

  useEffect(() => {
    getApplicantEmail_ACH_Number_Not_Exist(roleName, email);
  }, [roleName, email]);

  useEffect(() => {
    if (application) {
      const { event1validatedOn, applicationStage } = application;
      if (!event1validatedOn && applicationStage >= 6 && applicationStage !== 26) {
        setOldApplication(true);
      }
    }
  }, [application]);

  return (
    <div className="review-page ">
      <div className="d-flex flex-column">
        <div className="border-bottom mb-4 bg-white print">
          <div className="w-75 mx-auto">
            <div className="">
              <CommonNavigation ItemId={props.match.params.applicationID} />
            </div>
          </div>
        </div>
        <div className="text-center py-3 imagecon">
          <img src={images} alt="Image" className="ImagePrint p-0" />
        </div>
        {loading ? (
          <>
            <ApplicationPaymentsLoading />
            <ApplicationPaymentsLoading />
          </>
        ) : (
          <div className="container mt-4">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div id="files-upload" className="">
                  <div className="review-page">
                    <PaymentInformation />
                    {!oldApplication && (
                      <>
                        <Payment updatePaymentType={updatePaymentType} assignPayment={assignPayment} emails={emails} updateTransictionNumber={updateTransictionNumber} />

                        <AuthorizeApplicationFee
                          updateManualPayment={updateManualPayment}
                          editPaymentNotes={editPaymentNotes}
                          updatePaymentTransiction={updatePaymentTransiction}
                          updateTransictionId={updateTransictionId}
                          validatepayment={validatepayment}
                          setNetsuiteValue={setNetsuiteValue}
                          netsuiteField={netsuiteField}
                        />
                      </>
                    )}

                    {oldApplication && <OldApplication updateTransictionId={updateTransictionId} editPaymentNotes={editPaymentNotes} updatePaymentTransiction={updatePaymentTransiction} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Payment = ({ updatePaymentType, assignPayment, emails, updateTransictionNumber }) => {
  const [fee, setFee] = useState(null);
  const [me, setMe] = useState(true);
  const [errorTrans, setErrorTrans] = useState("");

  const application = useApplication();
  const { roleName = "", contact = {} } = useUser() || {};

  const {
    applicationStage,
    event1transactionNumber,
    event1transactionNumberDate,
    event1paymentType,
    event1applicationFee,
    event1engineeringFee,
    event1transactionFee,
    _id,
    event1paymentOn,
    event1transactionId,
    paymentby,
    payment,
    event1validatedOn,
  } = application;
  const { event1StripeResponse = [] } = payment;

  const applicationPaymentFee = event1applicationFee ? Number(event1applicationFee) : Number(fee?.applicationFee);
  const engineeringPaymentFee = event1engineeringFee ? Number(event1engineeringFee) : Number(fee?.engineeringFee);
  const transactionPaymentFee = event1transactionFee ? Number(event1transactionFee) : Number(fee?.transactionFee);
  const totalAmountForStripe = applicationPaymentFee + engineeringPaymentFee + transactionPaymentFee;
  const totalAmountForOfflinePayment = applicationPaymentFee + engineeringPaymentFee;

  const validatedStripeResponse = event1StripeResponse.find((each) => each?.validated === true);
  const validated = validatedStripeResponse?.validated || false;

  const paidStripeResponse = event1StripeResponse.find((each) => each?.payment_status === "paid");
  const payment_status = paidStripeResponse ? true : false;
  const payment_intent = paidStripeResponse?.payment_intent || "";

  const handleChange = (event) => {
    setErrorTrans(event.target.value);
  };

  const getFee = async (application) => {
    const fee = await getApplicationPaymentFee(application);
    setFee(fee);
  };

  useEffect(() => {
    if (!event1transactionFee || !event1applicationFee || !event1engineeringFee) {
      getFee(application);
    }
  }, [event1applicationFee, event1engineeringFee, event1transactionFee, application]);

  const isApplicant = () => roleName === "applicant";
  const isNotApplicant = () => roleName !== "applicant";
  const isAccountant = () => roleName === "Approving Accountant";

  const isOfflinePayment = () => event1paymentType === "Check" || event1paymentType === "ACH";
  const isOnlinePayment = () => payment_status || event1paymentType === "Stripe";
  const isPaymentNotStarted = () => applicationStage === 1 && !event1paymentType;
  const isPaymentComplete = () => isOfflinePayment() || isOnlinePayment();
  const isPaymentValidated = () => validated || event1validatedOn;
  const isCheckPayment = () => event1paymentType === "Check";
  const isACHPayment = () => event1paymentType === "ACH";
  const isInPaymentValidationStage = () => (applicationStage === 1 && isOfflinePayment()) || applicationStage === 26;
  const isNotPaymentValidated = () => !event1transactionNumber && event1transactionNumber !== "";
  const isInStage = (stage) => applicationStage === stage;
  const isStageGreaterThanOrEqualTo = (stage) => applicationStage >= stage;
  const paymentNotStarted = () => !event1paymentType && applicationStage === 1;
  const paymentInWaiting = () => paymentby?.status === "waiting";
  const isNotPaymentApplicant = () => contact?.email !== paymentby?.email;
  const isPaymentApplicant = () => contact?.email === paymentby?.email;

  return (
    <div className="accordion print" id="accordionExample1">
      <div className="accordion-item mb-4">
        <div className="card">
          <div className="card-body p-0">
            <h2 className="accordion-header border-bottom" id="PaymentSec">
              <button
                className=" accordion-button py-4 px-4 d-flex justify-content-between "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#Payment1"
                aria-expanded="false"
                aria-controls="Payment1"
              >
                Payment
              </button>
            </h2>
            <div id="Payment1" className="accordion-collapse show " aria-labelledby="PaymentSec" data-bs-parent="#accordionExample1">
              <div className="accordion-body p-0">
                <div className="inner-form  ">
                  <div className="container-fluid">
                    <div className="row">
                      {isNotApplicant() && paymentNotStarted() && (
                        <div className="col-lg-12 p-2">
                          <div className="alert alert-warning mt-3 text-dark" role="alert">
                            Applicant has not made the payment yet.
                          </div>
                        </div>
                      )}
                      {isAccountant() && paymentNotStarted() && (
                        <div className="col-lg-12 p-2">
                          <a
                            className="btn btn-block btn-outline-primary ms-0"
                            href="javascript:void(0)"
                            onClick={() => {
                              updatePaymentType("event1paymentType", "Check");
                            }}
                          >
                            Payment received by Check?
                          </a>
                          <a
                            className="btn btn-block btn-outline-primary ms-0"
                            href="javascript:void(0)"
                            onClick={() => {
                              updatePaymentType("event1paymentType", "ACH");
                            }}
                          >
                            Payment received by ACH?
                          </a>
                        </div>
                      )}

                      {/* Offline payment note */}
                      {isApplicant() && isInStage(1) && isOfflinePayment() && (
                        <div className="col-lg-12">
                          <div className="inner-form">
                            <div className="card mb-4 mt-2 bg-warning">
                              <div className="card-header bg-transparent d-print-none">
                                <h2 className="mb-0 text-white">
                                  <i className="fas fa-money-bill"></i> You have chosen to pay offline
                                </h2>
                              </div>
                              <div className="card-body">
                                {isCheckPayment() && (
                                  <div className="messages">
                                    <p className="d-print-none">
                                      We have notified the NCRR accounting team of your preference. This application will be on hold until the payment is processed. Please send your check to mailing
                                      address:
                                    </p>
                                    <strong>North Carolina Railroad Company</strong>
                                    <p className="d-print-none">
                                      Attn: Accounting Dept <br />
                                      2809 Highwoods Blvd <br />
                                      Raleigh, NC 27604
                                    </p>
                                    <p className="d-print-none">
                                      <strong> NOTE : </strong>
                                      Attach{" "}
                                      <a className="text-primary fw-bold" onClick={() => window.print()}>
                                        Print
                                      </a>
                                      of this payment page and send it along with your checks. Please send email with your check details at <span className="fw-bold">ar@ncrr.com</span>
                                    </p>
                                  </div>
                                )}
                                {isACHPayment() && (
                                  <>
                                    <div className="messages d-print-none">
                                      <p>
                                        We have notified the NCRR accounting team of your preference. This application will be on hold until the ACH is processed. Please reference the Application
                                        Number and remit to:
                                      </p>
                                      <p className="d-print-none">
                                        ACH Routing#: 053101121 <br />
                                        ACH Account#: 0005205335511
                                        <br />
                                        Bank: Truist
                                      </p>
                                    </div>
                                  </>
                                )}

                                {isCheckPayment() && (
                                  <div className="messages">
                                    <p>Acknowledgement Done for Check.</p>
                                  </div>
                                )}

                                {isACHPayment() && (
                                  <div className="messages">
                                    <p>Acknowledgement Done for ACH.</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="col-lg-12">
                        {isApplicant() && isInStage(1) && (
                          <>
                            <div className="card-body pb-0">
                              {/* me and Other radio */}
                              {paymentNotStarted() && (
                                <div className="mb-3">
                                  <div className="mb-2 mt-2">
                                    <div className="d-flex align-items-center mb-2">
                                      <div className="form-check">
                                        <input className="form-check-input SignByMe" onClick={() => setMe(true)} type="radio" checked={me} name="flexRadioDefault" id="Signedyes" />
                                        <label className="form-check-label" htmlFor="Signedyes">
                                          Me
                                        </label>
                                      </div>
                                      <div className="form-check ms-4">
                                        <input className="form-check-input SignByOthers" onClick={() => setMe(false)} checked={!me} type="radio" name="flexRadioDefault" id="signedno" />
                                        <label className="form-check-label" htmlFor="signedno">
                                          Others
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Payment waiting for Other applicant */}
                              {!me && <SelectForPayment assignPayment={assignPayment} />}

                              {/* Payment waiting for Other applicant */}
                              {paymentInWaiting() && isNotPaymentApplicant() && (
                                <>
                                  <div className="alert alert-warning mt-3 text-dark" role="alert">
                                    waiting for {paymentby?.name} to pay the application fee.
                                  </div>
                                  <div
                                    className="my-3 text-primary"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={assignPayment}
                                  >
                                    <u>Resend Email</u>
                                  </div>
                                </>
                              )}

                              {/* Payment waiting for Payment applicant PaymentCard */}
                              {me && isPaymentNotStarted() && (!paymentby || isPaymentApplicant()) && (
                                <PaymentCard
                                  totalAmountForStripe={totalAmountForStripe}
                                  applicationPaymentFee={applicationPaymentFee}
                                  engineeringPaymentFee={engineeringPaymentFee}
                                  updatePaymentType={updatePaymentType}
                                  _id={_id}
                                />
                              )}
                            </div>
                          </>
                        )}

                        {/* Payment Complete */}
                        {/* And Not Yet Validated */}
                        {isOfflinePayment() && (
                          <div className="field-col mt-4 ml-2">
                            <h3>Payment Method </h3>
                            <p className="d-flex justify-content-between p-0 align-items-center">
                              <span>
                                Payment Type: <strong>{event1paymentType || "Stripe"}</strong>
                                {isPaymentValidated() && (
                                  <>
                                    <br /> Payment Received:{" "}
                                    <strong>
                                      ${isOnlinePayment() && roleName === "applicant" ? totalAmountForStripe : totalAmountForOfflinePayment}
                                      {isOfflinePayment() && Number(engineeringPaymentFee) + Number(applicationPaymentFee)}
                                    </strong>
                                  </>
                                )}
                                <br />
                                {isNotPaymentValidated() && isACHPayment() && (isApplicant() || isAccountant()) && (
                                  <div className="mb-4">
                                    <br />
                                    <h3>ACH Transaction Trace Number</h3>
                                    <input required className="form-control" id="transactionIds" name="transactionIds" onChange={handleChange} value={errorTrans} />
                                    <span className="text-danger ps-2">
                                      <span>{emails.includes(contact.email) ? "" : errorTrans === "" ? "* This field is required" : null}</span>
                                    </span>
                                  </div>
                                )}
                                {event1transactionNumber && event1paymentType === "ACH" && (
                                  <>
                                    ACH Transaction Trace Number : <strong>{event1transactionNumber && event1transactionNumber}</strong>
                                  </>
                                )}
                              </span>
                              {isOnlinePayment() && isAccountant() && (
                                <a href={`${PAYMENT_LINK}${payment_intent}`} target="_blank" className="btn btn-link p-2">
                                  Payment Intent
                                </a>
                              )}
                            </p>
                          </div>
                        )}

                        {isOnlinePayment() && (
                          <div className="field-col mt-4 ml-2">
                            <h3>Payment Method </h3>
                            <p className="d-flex justify-content-between p-0 align-items-center">
                              <span>
                                Payment Type: <strong>Stripe</strong>
                                <br /> Payment Received: <strong>${roleName === "applicant" ? totalAmountForStripe : totalAmountForOfflinePayment}</strong>
                                <br />
                              </span>
                              {isAccountant() && (
                                <a href={`${PAYMENT_LINK}${payment_intent}`} target="_blank" className="btn btn-link p-2">
                                  Payment Intent
                                </a>
                              )}
                            </p>
                          </div>
                        )}

                        {isOfflinePayment() && isApplicant() && !isPaymentValidated() && (
                          <div className="field-col mt-4 ml-2">
                            <h3>Other Payment Methods?</h3>
                            <PaymentCard
                              _id={_id}
                              totalAmountForStripe={totalAmountForStripe}
                              applicationPaymentFee={applicationPaymentFee}
                              engineeringPaymentFee={engineeringPaymentFee}
                              updatePaymentType={updatePaymentType}
                              paymentType={event1paymentType}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                {/* Non ACH After Payment */}
                {!event1transactionNumber && event1transactionNumber !== "" && event1paymentOn && event1paymentType !== "ACH" && (
                  <div className="card-footer py-0 justify-content-center bg-success">
                    <a className="d-block text-white disabled py-4 px-0" tabIndex="-1" role="button" aria-disabled="true">
                      <span className="d-flex justify-content-between align-items-center">
                        <span>
                          <i className="fal fa-check"></i> {"Paid"}
                        </span>
                        <span>Submit By Applicant on {event1paymentOn && <small> {event1paymentOn}</small>}</span>
                      </span>
                    </a>
                  </div>
                )}

                {/* For ACH For Applicant before Adding transactionNumber */}
                {!event1transactionNumber && event1transactionNumber !== "" && event1paymentType === "ACH" && (isApplicant() || isAccountant()) && (
                  // eslint-disable-next-line react/jsx-no-comment-textnodes
                  <div className="card-footer py-0 justify-content-center bg-primary">
                    <a
                      className={`${errorTrans !== "" || emails.includes(contact.email) ? "d-block text-white py-4 px-0" : "d-block text-white py-4 px-0 disabled"}`}
                      tabIndex="-1"
                      role="button"
                      onClick={updateTransictionNumber}
                    >
                      <span className="d-flex justify-content-between align-items-center">
                        <span>
                          {"Submit"} <i className="fal fa-chevron-right ms-2"></i>
                        </span>
                      </span>
                    </a>
                  </div>
                )}

                {/* For ACH For Others Once the User submitted the ach but not filled transactionNumber */}
                {!event1transactionNumber && event1transactionNumber !== "" && !isApplicant() && !isAccountant() && event1paymentType === "ACH" && (
                  <div
                    className="card-footer justify-content-center "
                    style={{
                      backgroundColor: "rgb(233 237 241)",
                    }}
                  >
                    Awaiting for Applicant
                    <i className="fal fa-chevron-right ms-2"></i>
                  </div>
                )}

                {/* For ACH After Adding transactionNumber */}
                {(event1transactionNumber || event1transactionNumberDate) && (
                  <div className="card-footer py-0 justify-content-center bg-success">
                    <a className="d-block text-white btn border-0 disabled py-4 px-0" tabIndex="-1" role="button" aria-disabled="true">
                      <span className="d-flex justify-content-between align-items-center">
                        <span>
                          <i className="fal fa-check"></i> {"Paid"}
                        </span>
                        <span>By Applicant on {event1transactionNumberDate && <small> {event1transactionNumberDate}</small>}</span>
                      </span>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddContactModal assignPayment={assignPayment} />
    </div>
  );
};

const PaymentCard = ({ totalAmountForStripe, applicationPaymentFee, engineeringPaymentFee, updatePaymentType, _id, paymentType = "" }) => {
  const application = useApplication();
  return (
    <form action={`${API_URL}/create-checkout-session`} method="POST">
      <div className="pay-card my-3">
        <div className="divider position-relative">
          <hr />
          <p className="divider-txt">
            <small className="text-muted">Pay with card</small>
          </p>
        </div>
        <button type="submit" className="btn btn-block btn-primary">
          Pay with Card $<span>{totalAmountForStripe}</span>
          <small className="d-block">3.01% convenience charge applicable</small>
        </button>
      </div>
      {/* {!isExpeditedApplication(application) && ( */}
      <div className="pay-card mb-3">
        <div className="divider position-relative">
          <hr />
          <p className="divider-txt">
            <small className="text-muted">Pay Offline</small>
          </p>
        </div>
        {applicationPaymentFee && engineeringPaymentFee ? (
          <>
            {paymentType !== "Check" && (
              <a
                className="btn btn-block btn-outline-primary ms-0"
                href="javascript:void(0)"
                onClick={() => {
                  updatePaymentType("event1paymentType", "Check");
                }}
              >
                Pay with Check $<span>{Number(engineeringPaymentFee) + Number(applicationPaymentFee)}</span>
              </a>
            )}

            {paymentType !== "ACH" && (
              <a
                className="btn btn-block btn-outline-primary ms-0"
                href="javascript:void(0)"
                onClick={() => {
                  updatePaymentType("event1paymentType", "ACH");
                }}
              >
                Pay with ACH $<span>{Number(engineeringPaymentFee) + Number(applicationPaymentFee)}</span>
              </a>
            )}
          </>
        ) : (
          <>
            <PaymentsLoading /> <PaymentsLoading />
          </>
        )}
      </div>
      {/* )} */}
      <input type="hidden" name="product_quantity" value="1" />
      <input type="hidden" name="success_url" value={`${REACT_APP_URL}/applicationPaymentWaiting/${_id}?success=true`} />
      <input type="hidden" name="applicationID" value={_id} />
      <input
        type="hidden"
        name="cancel_url"
        value={`${REACT_APP_URL}/applicationPayment/${_id}?canceled=true
`}
      />
    </form>
  );
};

const SelectForPayment = ({ assignPayment }) => {
  const application = useApplication();
  const user = useUser();
  const [facilityContacts, setFacilityContacts] = useState([]);
  const [consultantContacts, setConsultantContacts] = useState([]);
  const [applicationContacts, setApplicationContacts] = useState([]);

  const [selectedContact, setSelectedContact] = useState(null);

  const getFacilityContacts = async (companyID, applicantDetails) => {
    const res = await getContactsByCompanyId(companyID);
    if (res.data.status) {
      const contacts = res.data.data;
      const { primaryContact, billingContact, consultantContact, signatoryContact, engineeringContact } = applicantDetails;
      const filteredContacts = contacts.filter((each) => {
        if (each.id === primaryContact?.id) {
          return false;
        }
        if (each.id === billingContact?.id) {
          return false;
        }
        if (each.id === consultantContact?.id) {
          return false;
        }
        if (each.id === engineeringContact?.id) {
          return false;
        }
        if (each.id === signatoryContact?.id) {
          return false;
        }
        return true;
      });
      setFacilityContacts(filteredContacts);
    }
  };

  const getConsultantContacts = async (companyID, applicantDetails) => {
    const res = await getContactsByCompanyId(companyID);
    if (res.data.status) {
      const contacts = res.data.data;
      const { primaryContact, billingContact, consultantContact, signatoryContact, engineeringContact } = applicantDetails;
      const filteredContacts = contacts.filter((each) => {
        if (each.id === primaryContact?.id) {
          return false;
        }
        if (each.id === billingContact?.id) {
          return false;
        }
        if (each.id === consultantContact?.id) {
          return false;
        }
        if (each.id === engineeringContact?.id) {
          return false;
        }
        if (each.id === signatoryContact?.id) {
          return false;
        }
        return true;
      });
      setConsultantContacts(filteredContacts);
    }
  };

  const getApplicationContacts = (applicantDetails) => {
    const { primaryContact, billingContact, consultantContact, signatoryContact, engineeringContact } = applicantDetails;
    const applicationContacts = [];

    if (billingContact) {
      if (!applicationContacts.some((each) => each.id === billingContact.id)) {
        applicationContacts.push(billingContact);
      }
    }
    if (primaryContact) {
      if (!applicationContacts.some((each) => each.id === primaryContact.id)) {
        applicationContacts.push(primaryContact);
      }
    }
    if (consultantContact) {
      if (!applicationContacts.some((each) => each.id === consultantContact.id)) {
        applicationContacts.push(consultantContact);
      }
    }
    if (signatoryContact) {
      if (!applicationContacts.some((each) => each.id === signatoryContact.id)) {
        applicationContacts.push(signatoryContact);
      }
    }
    if (engineeringContact) {
      if (!applicationContacts.some((each) => each.id === engineeringContact.id)) {
        applicationContacts.push(engineeringContact);
      }
    }
    setApplicationContacts(applicationContacts);
  };

  useEffect(() => {
    if (application) {
      const { consultantId, facilityId, applicantDetails } = application;
      if (consultantId) {
        getConsultantContacts(consultantId, applicantDetails);
      }
      if (facilityId) {
        getFacilityContacts(facilityId, applicantDetails);
      }
      if (applicantDetails) {
        getApplicationContacts(applicantDetails);
      }
    }
  }, [application]);

  if (!application || !user) {
    return <DashBoardLoading />;
  }

  const handleSelectChange = (id) => {
    let contact = null;

    if (id === "NEW") {
      setSelectedContact(id);
      return;
    }

    if (!contact) {
      contact = applicationContacts.find((each) => each.id === id);
    }

    if (!contact) {
      contact = facilityContacts.find((each) => each.id === id);
    }
    if (!contact) {
      contact = consultantContacts.find((each) => each.id === id);
    }

    setSelectedContact(contact);
  };

  return (
    <div className="card bg-secondary border-0 my-3">
      <div id="div1" className="card-body p-3">
        <div>
          <div className="input-group" role="group">
            <select className="form-select" id="search-select" onChange={(e) => handleSelectChange(e.target.value)} aria-label="Default select example">
              <option value="" selected disabled>
                Select contact for Payment
              </option>
              <optgroup
                label="Application Contacts"
                style={{
                  color: "gray",
                }}
              >
                {applicationContacts.map((each) => {
                  return <option value={each?.id}>{`${each.name} (${each?.email})`}</option>;
                })}
              </optgroup>
              {facilityContacts.length > 0 && (
                <optgroup
                  label="Facility Contacts"
                  style={{
                    color: "gray",
                  }}
                >
                  {facilityContacts.map((each) => {
                    return <option value={each?.id}>{`${each.name} (${each?.email})`}</option>;
                  })}
                </optgroup>
              )}
              {consultantContacts.length > 0 && (
                <optgroup
                  label="Engineering Contacts"
                  style={{
                    color: "gray",
                  }}
                >
                  {consultantContacts.map((each) => {
                    return <option value={each?.id}>{`${each.name} (${each?.email})`}</option>;
                  })}
                </optgroup>
              )}
              <optgroup
                label="New"
                style={{
                  color: "gray",
                }}
              >
                <option value={"NEW"}>Add New Contact</option>
              </optgroup>
            </select>
            {selectedContact && selectedContact !== "NEW" && (
              <div id="hidden_div" className="dropdown-content-bond">
                <button
                  type="button"
                  className="btn btn-success"
                  style={{
                    borderRadius: "0 6px 6px 0",
                    height: "100%",
                    paddingBottom: "0.7rem !important",
                    paddingTop: " 0.75rem !important",
                  }}
                  onClick={() => assignPayment(selectedContact)}
                >
                  Send
                </button>
              </div>
            )}
            {selectedContact === "NEW" && (
              <div id="hidden_div2" className="dropdown-content-bond">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop22"
                  className="btn btn-success"
                  style={{
                    borderRadius: "0 6px 6px 0",
                    height: "100%",
                    paddingBottom: "0.7rem !important",
                    paddingTop: " 0.75rem !important",
                  }}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const AddContactModal = ({ assignPayment }) => {
  const application = useApplication();
  const user = useUser();
  const [contact, setContact] = useState({
    name: "",
    email: "",
    role: "",
  });
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (user) {
      const { company } = user;
      if (company) {
        const { companyType } = company;
        if (companyType === "FACILITY") {
          const roles = [
            {
              name: "role",
              value: "Primary Representative",
              label: "Primary Representative",
            },
            {
              name: "role",
              value: "Billing Representative",
              label: "Billing Representative",
            },
          ];
          setRoles(roles);
        }

        if (companyType === "CONSULTANT") {
          const roles = [
            {
              name: "role",
              value: "Primary Representative",
              label: "Primary Representative",
            },
            {
              name: "role",
              value: "Billing Representative",
              label: "Billing Representative",
            },
            {
              name: "role",
              value: "Engineering Representative",
              label: "Engineering Representative",
            },
          ];
          setRoles(roles);
        }
      }
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contact.name || !contact.email || !contact.role) {
      return;
    }

    const { facilityId, consultantId } = application;
    const { name, email, role } = contact;

    const data = {
      name,
      jobTitle: "",
      email,
      phone: "",
      role: [role],
      default: false,
      address: {
        address: "",
        city: "",
        state: "",
        zip: "",
        poBox: "",
        country: "United States",
      },
    };

    if (role === "Primary Representative" || role === "Billing Representative") {
      data["companyId"] = facilityId;
    }

    if (role === "Engineering Representative") {
      data["companyId"] = consultantId;
    }

    await createContact(data);
    await assignPayment(data);
  };

  const handleChange = (e) => {
    if (e?.name) {
      setContact({ ...contact, [e.name]: e.value });
      return;
    }
    setContact({ ...contact, [e.target.name]: e.target.value });
  };

  return (
    <div className="modal fade" id="staticBackdrop22" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <label htmlFor="">Add Contact</label>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input required={true} type="text" name="name" onChange={handleChange} className="form-control mb-3" id="name" placeholder="Enter Name" />
              <label htmlFor="email" className="form-label">
                Email address
              </label>
              <input required={true} type="email" name="email" onChange={handleChange} className="form-control" id="email" placeholder="Enter Email Address" />
              <div className="mt-3">
                <label className="form-label d-flex justify-content-between">Role</label>
                <Select placeholder="Select Roles" required={true} onChange={handleChange} options={roles} />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button type="submit" className="btn btn-success">
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ApplicationPayment;
